import React, {useState,useEffect,useMemo} from 'react';
import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import FirstConfirm from './FirstConfirm';
import PortraitIcon from '@mui/icons-material/Portrait';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import DoneIcon from '@mui/icons-material/Done';
import ColInput from './ColInput';
import {Owner,Exam} from './Inc';
import Ajax from './Ajax';
import Toast from './Toast';
import Title from './Title';
//import Success from './Success';
import Loading from './Loading';

interface FirstInputProps {
	owner:Owner,
}

const FirstInput = (props:FirstInputProps)=> {
	const classes = useStyles();
	const cats:string[] = ["アクセサリー","豆本","本・同人誌","ポストカード・イラスト","演劇","文房具・ホビー","生活雑貨"];

	const def:Exam = {
		name: props.owner.customer.name,
		kana: props.owner.customer.kana,
		mail: props.owner.customer.mail,
		group: props.owner.owner_name,
		cat: cats[0],
		text1: "",
		text2: "",
		text3: "",
		url: "",
		customer_id: 0,
	}
	const [values, setValues] = useState(def);
	const [toast,setToast] = useState("");
	const [flags,setFlags] = useState({
		errors: [] as string[],
		isThanks: false,
		isLoading: false,
		isConfirm: false,
		isSuccess: false,
	});

	const handleModalClose = ()=>{
		setFlags({...flags,"isConfirm":false});
	};

	const handleChange = (name: keyof Exam) => (event: React.ChangeEvent<HTMLInputElement>) => {
		setValues({ ...values, [name]: event.target.value });
	};

	const change = (name:keyof Exam,value:string)=>{
		setValues(prev=>({...prev,[name]:value}));
	}
	const addError = (name:keyof Exam,isError:boolean) =>{
		setFlags(prev => {
			const errors = [...prev.errors];
			if( isError ){
				if( !errors.includes(name) ){
					errors.push( name );
				}
			} else {
				if( errors.includes(name) ){
					const index = errors.findIndex((v) => v===name);
					errors.splice(index,1);
				}
			}
			return { ...prev, errors: errors }
		});
	}

	// const radios = (id:keyof Exam,list:string[])=>{
	// 	let value = values[id];

	// 	const tmp = list.map( (label:string,index:number)=>{
	// 		const key = id+index;
	// 		return (
	// 			<FormControlLabel key={key} value={label} control={<Radio color="primary" disabled={props.owner.review_flag==="1"} onChange={handleChange(id)} className={classes.radio}/>} label={label} />
	// 		);
	// 	});
	// 	return (
	// 		<RadioGroup
	// 			className={classes.radiogroup}
	// 			value={String(value)}
	// 			row
	// 		>
	// 			{tmp}
	// 		</RadioGroup>
	// 	)
	// };

    const closeToast = ()=>{
		setToast("");
	}
	const closeSuccess = ()=>{
		setFlags({...flags,isSuccess:false});
		//isThanks = false;
	}
	const validate = ()=>{
		let error = false;
		if( values.name==="" || values.kana==="" || values.mail==="" || values.cat==="" || values.text1==="" ){
			error = true;
		}
		if( error ){
			setToast("まだ入力されていない欄があります。");
		} else {
			setFlags({...flags,"isConfirm":true});
		}
	}
	const send = ()=>{
		values.customer_id = props.owner.customer.customer_id;

		setFlags({...flags,"isLoading":true});
		//setFlags({"isLoading":false,"isConfirm":false,"isSuccess":true});
		//setValues(def);
		
		Ajax.send("first/send",values,(res:any)=>{
			if( res.ok ){
				//isThanks = true;
				setFlags({"errors":[],"isLoading":false,"isConfirm":false,"isSuccess":true,"isThanks":true});
				setValues(def);
				window.scrollTo(0, 0);
			} else {
				setFlags({"errors":[],"isLoading":false,"isConfirm":false,"isSuccess":false,"isThanks":false});
				setToast("送信に失敗しました。");
			}
		});
		
	}
	const guide1 = useMemo( ()=>{
		return (
			<React.Fragment>
			<p className={classes.p}>初めて架空ストアに登録をされた作家さんは、最初の納品の前にこちらのフォームでご連絡下さい。簡単な事前審査を行います。</p>
			<p className={classes.p}>審査のポイントは３つです。</p>
			<ol style={{margin:"1em 0",padding:"1em",paddingLeft:"2em",border:'1px solid silver',borderRadius:'0.5em'}}>
				<li>架空ストアの雰囲気に合っているか。</li>
				<li>架空ストアで取り扱いできない作品でないか</li>
				<li>作品の質に責任を持てそうな作家さんであるかどうか。</li>
			</ol>
			<p className={classes.p}>
			作品については、さらに詳しい説明をお願いしたり、作品の写真を数枚送っていただいたりする場合もございます。<br/>
			</p>
			<p className={classes.p}>
			どうぞ気軽にご連絡下さい。<br/>
			</p>
			</React.Fragment>
		)
	},[]);
	const guide2 = useMemo( ()=>{
		return (
		<div>
			<p className={classes.hintFirst}>
				※戯曲（電子書籍）は事前審査が不要です。<br/>
				※審査結果が不可となった場合、その理由の説明や作品についてのアドバイス等は一切いたしません。あらかじめご了承ください。<br/>
				※ご利用のメールのセキュリティ設定によっては、架空ストアからのメールが「迷惑メール」扱いになってしまうことがあります。メールが届かない場合は、「迷惑メール」フォルダの中を念のためご確認下さい。<br/>
			</p>
			<Divider/>
			<p style={{textAlign:"center"}}>
				架空ストアのメールアドレス<br/>
				<b style={{fontSize:"120%"}}>store@retro-biz.com</b>
			</p>
			<Divider/>
		</div>
		)
	},[]);

	useEffect( ()=>{
        const defErrors = ["name","kana","mail","text1"];

        // defErrorsの各要素をキーにして、valuesにそのキーが存在して値が空でないならば、defErrorsからこのキーを削除する
        // なお、valuesはuseStateで定義されている
        const errors = defErrors.filter((key) => {
            return !values[key as keyof Exam] || (values[key as keyof Exam] as string).trim() === "";
        });
        setFlags({"errors":errors,"isLoading":false,"isConfirm":false,"isSuccess":false,"isThanks":false});
		window.scrollTo(0,0);
	},[]);

	return (
		<div className={classes.root}>
			<Grid container spacing={2}>
				{flags.isThanks ? (
				<Grid item xs={12} md={12}>
					<Paper className={classes.paper}>
						<Title text="事前審査" icon="store"/>
						<div style={{marginBottom:"3em"}}>
							<Title text="メールを送信しました" size={2}/>
							<div className={classes.section}>
								<p><b>store@retro-biz.com</b>から確認メールを送信しましたのでご確認下さい。</p>
								<p>数時間経過しても確認メールが届かない場合は入力されたメールアドレスが正しくない可能性がありますので、お手数ですが再度お問い合わせをお願いいたします。</p>
							</div>
							<div className={classes.section}>
								<p>通常１営業日以内に当店担当者からご連絡を差し上げます。</p>
								<p>それ以上たっても返信がない場合は架空ストアからのメールが迷惑メール扱いになってしまっている可能性がありますので、お手数ですが迷惑メールフォルダなどをご確認いただくか、別のメールアドレスで再度ご連絡をお願いいたします。</p>
							</div>
						</div>
					</Paper>
				</Grid>
				):(
				<React.Fragment>
				<Grid item xs={12} md={8}>
					<Paper className={classes.paper}>
						{props.owner.review_flag==="1" ? (
						<Title text="事前審査（済）" icon="done"/>
						):(
						<Title text="事前審査" icon="store"/>
						)}
						<Hidden mdUp implementation="js">
							<div className="firstTalk">
								{guide1}
							</div>
							<div style={{textAlign:'center',marginBottom:'2em'}}>
								<ArrowDownwardIcon style={{fontSize:'4em',color:'silver'}}/>
							</div>
						</Hidden>


						{ props.owner.owner_id===0 && (
						<div style={{marginBottom:'1em',textAlign:'center'}}>
							先に作家プロフィールを入力して下さい。<br/>
							作家プロフィールの内容も審査の参考となります。<br/>
							<div style={{marginTop:'3em',marginBottom:'6em',display:'flex',justifyContent:'center'}}>
								<Link to="/profile"><Button variant="contained" color="primary">
									<PortraitIcon style={{marginRight:'0.25em'}}/> 作家プロフィールを入力する
								</Button></Link>
							</div>
						</div>
						)}
						{ props.owner.owner_id>0 && (
						<>
						<div style={{marginBottom:"2em"}}>
							<Grid container spacing={2}>
								<Grid item xs={12} sm={6}>
									<ColInput name="お名前" value={values.name} addError={addError} change={change} maxLength={50} id="name" helper="50文字以内" placeholder='津島修治' type="text" disabled={props.owner.review_flag==="1"} required/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<ColInput name="お名前（カナ）" value={values.kana} addError={addError} change={change} maxLength={50} id="kana" helper="50文字以内" placeholder='ツシマシュウジ' type="text" disabled={props.owner.review_flag==="1"} required/>
								</Grid>
								<Grid item xs={12} sm={12}>
									<ColInput name="作家名・サークル名" value={values.group} addError={addError} change={change} maxLength={50} id="group" helper="50文字以内・省略可" placeholder="太宰治" type="text" disabled={props.owner.review_flag==="1"}/>
								</Grid>
								<Grid item xs={12} sm={12}>
									<ColInput name="メールアドレス" value={values.mail} addError={addError} change={change} maxLength={100} id="mail" helper="100文字以内" type="text" disabled={props.owner.review_flag==="1"} required/>
								</Grid>
							</Grid>
						</div>
						<div className={classes.section}>
							<Grid container spacing={2}>
								<Grid item xs={12} sm={12}>
									<ColInput name="作品のジャンル" value={values.cat} addError={addError} change={change} id="cat" type="radio" words={cats} frontHelper="ジャンルを一つ選んで下さい。いろいろある場合は、主なものを一つ選んでいただければＯＫです。" disabled={props.owner.review_flag==="1"}/>
								</Grid>
								<Grid item xs={12} sm={12}>
									<ColInput name="作品の詳細" value={values.text1} addError={addError} change={change} maxLength={1000}
                                        id="text1" helper="1000文字以内"
                                        type="textarea" rows={4} disabled={props.owner.review_flag==="1"}
                                        frontHelper={values.cat!=="豆本" ? "納品したい作品について簡単にＰＲをお願いします。": "どのような豆本作品を納品したいと考えていますか？（豆本の内容、素材、製本方法、大きさなど）"}
                                        required/>
								</Grid>

								<Grid item xs={12} sm={6}>
									<ColInput name="その他の作品" value={values.text2} addError={addError} change={change} maxLength={1000}
                                        id="text2" helper="1000文字以内・省略可"
                                        type="textarea" rows={4} disabled={props.owner.review_flag==="1"}
                                        frontHelper="今回納品を考えている作品以外にも、あなたが作っているものがありましたら参考までに教えて下さい。"/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<ColInput name="活動について" value={values.text3} addError={addError} change={change} maxLength={1000}
                                        id="text3" helper="1000文字以内・省略可"
                                        type="textarea" rows={4} disabled={props.owner.review_flag==="1"}
                                        frontHelper={values.cat!=="豆本" ? "イベントへの参加実績などありましたら教えて下さい。": "豆本制作歴やイベントなどへの参加実績がありましたら教えて下さい。（豆本以外の活動についてでも構いません）"}/>
								</Grid>
								<Grid item xs={12} sm={12}>
									<ColInput name="ブログやサイトのURL" value={values.url} addError={addError} change={change} maxLength={300}
                                    id="url" helper="300文字以内・省略可" type="text"
                                    frontHelper="作品や活動の様子が分かるブログやサイトがありましたらURLを教えて下さい。"
                                    placeholder="https://"
                                    disabled={props.owner.review_flag==="1"}/>
								</Grid>
							</Grid>
						</div>
						<div style={{display:"flex",justifyContent:"flex-end",marginTop:"2em",gap:"1em"}}>
							{ props.owner.review_flag==="1" &&
							<div style={{display:"flex",justifyContent:"flex-end",gap:"0.5em"}}>
								<DoneIcon style={{color:"green",fontSize:"2em"}}/>
								<div style={{color:"green"}}>事前審査済</div>
							</div>}

							<Button variant="contained" disabled={props.owner.review_flag==="1" || flags.errors.length>0} onClick={validate}>内容の確認</Button>
						</div>
						</>)}

						<Hidden mdUp implementation="js">
							<div style={{marginTop:"4em"}}>
								<Divider/>
								{guide2}
							</div>
						</Hidden>

					</Paper>
				</Grid>
				<Hidden mdDown implementation="js">
					<Grid item xs={12} md={4}>
						<Paper className={classes.paper}>
							<Title text="初めての納品の前に" size={2}/>
							{guide1}
							<Divider/>
							{guide2}
						</Paper>
					</Grid>
				</Hidden>

				</React.Fragment>
				)}
			</Grid>
			<FirstConfirm send={send} isOpen={flags.isConfirm} close={handleModalClose} exam={values}/>
			<Toast close={closeToast} mes={toast}/>
			<Loading isLoading={flags.isLoading}/>
		</div>
	);
}

export default FirstInput;
